/* eslint-disable react/jsx-no-target-blank */
import { useAuth } from '../../../../app/modules/auth'
import { KTIcon } from '../../../helpers'
import { useNavigate } from 'react-router-dom'

const SidebarFooter = () => {
  const navigate = useNavigate()
  const { isFacilityManager, saveAuth, auth, currentUser }: any = useAuth()
  return (
    <>

      {isFacilityManager || currentUser?.userType !== 'CLIENT' ? <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
        {/* <a
        // target='_blank'
        // href={process.env.REACT_APP_PREVIEW_DOCS_URL}
        href='/apps/help-desk'
        className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        data-bs-dismiss-='click'
        title='AdminApp Docs & Components'
      >
        <span className='btn-label'>Help Desk</span>
        <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
      </a> */}
        {isFacilityManager && (
          <button
            className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
            data-bs-toggle='tooltip'
            data-bs-trigger='hover'
            data-bs-dismiss='click'
            title='AdminApp Docs & Components'
            onClick={() => {
              saveAuth({
                ...auth,
                data: { ...auth.data, isSwitchAccount: true },
              })
              navigate('/auth/switch-account')
            }}
          >
            <span className='btn-label'>Switch Facility</span>
            <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
          </button>
        )}
        <br />
        <br />
        {/* <button
        className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        data-bs-dismiss='click'
        title='AdminApp Docs & Components'
        onClick={() => {
          navigate('/apps/help-desk')
        }}
      >
        <span className='btn-label'>Help Desk</span>
        <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
      </button> */}

        {currentUser?.userType !== 'CLIENT' && (
          <button
            className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
            data-bs-toggle='tooltip'
            data-bs-trigger='hover'
            data-bs-dismiss='click'
            title='AdminApp Docs & Components'
            onClick={() => {
              navigate('/apps/help-desk')
            }}
          >
            <span className='btn-label'>Help desk</span>
            <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
          </button>
        )}
      </div> : null}
    </>
  )
}

export { SidebarFooter }
